(() => {
  const STORAGE_KEY = 'curacoro_wishlist';
  const BUTTON_SELECTOR = '[data-wishlist-button]';
  const COUNT_SELECTOR = '[data-wishlist-count]';
  const PAGE_SELECTOR = '[data-wishlist-page]';

  function getWishlist() {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));

      return Array.isArray(saved) ? saved : [];
    } catch (error) {
      console.warn('Unable to read wishlist:', error);
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      console.warn('Unable to save wishlist:', error);
    }
  }

  function normalizeProduct(product) {
    return {
      id: String(product.id || ''),
      handle: product.handle || '',
      title: product.title || '',
      url: product.url || '',
      image: product.image || '',
      price: product.price || '',
      compareAtPrice: product.compareAtPrice || '',
      variantId: String(product.variantId || '')
    };
  }

  function hasProduct(productId) {
    return getWishlist().some(
      item => String(item.id) === String(productId)
    );
  }

  function addProduct(product) {
    const wishlist = getWishlist();
    const normalizedProduct = normalizeProduct(product);

    if (!normalizedProduct.id || hasProduct(normalizedProduct.id)) {
      return;
    }

    wishlist.push(normalizedProduct);
    saveWishlist(wishlist);
  }

  function removeProduct(productId) {
    const wishlist = getWishlist().filter(
      item => String(item.id) !== String(productId)
    );

    saveWishlist(wishlist);
  }

  function toggleProduct(product) {
    if (hasProduct(product.id)) {
      removeProduct(product.id);
      return false;
    }

    addProduct(product);
    return true;
  }

  function parseButtonProduct(button) {
    return {
      id: button.dataset.productId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      compareAtPrice: button.dataset.productCompareAtPrice,
      variantId: button.dataset.variantId
    };
  }

  function updateButtons() {
    document.querySelectorAll(BUTTON_SELECTOR).forEach(button => {
      const isActive = hasProduct(button.dataset.productId);

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));

      const label = button.querySelector('[data-wishlist-label]');

      if (label) {
        label.textContent = isActive
          ? 'Remove from wishlist'
          : 'Add to wishlist';
      }
    });
  }

  function updateCount() {
    const count = getWishlist().length;

    document.querySelectorAll(COUNT_SELECTOR).forEach(element => {
      element.textContent = count;
      element.hidden = count === 0;
    });
  }

  function escapeHtml(value) {
    const element = document.createElement('div');
    element.textContent = value || '';
    return element.innerHTML;
  }


  function plainText(value) {
    const element = document.createElement('div');
    element.innerHTML = value || '';
    return element.textContent || '';
  }
  function renderWishlistPage() {
    const container = document.querySelector(PAGE_SELECTOR);

    if (!container) {
      return;
    }

    const wishlist = getWishlist();

    if (wishlist.length === 0) {
      container.innerHTML = `
        <div class="local-wishlist__empty">
          <h2>Your wishlist is empty</h2>
          <p>Save the products you love and find them here later.</p>
          <a href="/collections/all" class="btn">
            Continue shopping
          </a>
        </div>
      `;

      return;
    }

    container.innerHTML = wishlist.map(product => `
      <article class="local-wishlist-card" data-wishlist-card="${escapeHtml(product.id)}">
        <a class="local-wishlist-card__image" href="${escapeHtml(product.url)}">
          ${
            product.image
              ? `<img
                  src="${escapeHtml(product.image)}"
                  alt="${escapeHtml(product.title)}"
                  loading="lazy"
                >`
              : ''
          }
        </a>

        <div class="local-wishlist-card__content">
          <a
            class="local-wishlist-card__title"
            href="${escapeHtml(product.url)}"
          >
            ${escapeHtml(product.title)}
          </a>

          ${
            product.price
              ? `<div class="local-wishlist-card__price">
                  ${escapeHtml(plainText(product.price))}
                </div>`
              : ''
          }

          <div class="local-wishlist-card__actions">
            <a href="${escapeHtml(product.url)}" class="btn btn--small">
              View product
            </a>

            <button
              type="button"
              class="local-wishlist-card__remove"
              data-remove-wishlist="${escapeHtml(product.id)}"
              aria-label="Remove ${escapeHtml(product.title)} from wishlist"
            >
              Remove
            </button>
          </div>
        </div>
      </article>
    `).join('');
  }

  function refreshWishlistUI() {
    updateButtons();
    updateCount();
    renderWishlistPage();
  }

  document.addEventListener('click', event => {
    const wishlistButton = event.target.closest(BUTTON_SELECTOR);

    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();

      const product = parseButtonProduct(wishlistButton);
      toggleProduct(product);
      refreshWishlistUI();

      return;
    }

    const removeButton = event.target.closest('[data-remove-wishlist]');

    if (removeButton) {
      removeProduct(removeButton.dataset.removeWishlist);
      refreshWishlistUI();
    }
  });

  document.addEventListener('DOMContentLoaded', refreshWishlistUI);

  document.addEventListener('shopify:section:load', refreshWishlistUI);
  document.addEventListener('shopify:section:reorder', refreshWishlistUI);

  window.addEventListener('storage', event => {
    if (event.key === STORAGE_KEY) {
      refreshWishlistUI();
    }
  });

  window.CuracoroWishlist = {
    get: getWishlist,
    add: addProduct,
    remove: removeProduct,
    toggle: toggleProduct,
    refresh: refreshWishlistUI
  };
})();